import React, { useEffect, useRef, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal } from "react-bootstrap";
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import { useSelector } from 'react-redux';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';

const AddNewAdvanceDirectives = (props) => {
  // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
  const { isOpenAdvanceDirectives, onClose, onDeleteAdvanceDirectives } = { ...props }
  let { patientID, IsEditAllowed } = props;
  const API_URL = enumUtil.controller.General
  let AdvanceDirectives_Modal = {
    Notes: "",
    // AdvanceDirectivesSearch: "",
    // OnsetDate: "",
    // Status: "",
  }
  let valModal = {}
  let ValidationModal = {
    // AdvanceDirectivesSearchVal: "",
    NotesVal: "",
    // StatusVal: "",
  }
  const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
  const [advanceDirectivesID, setAdvanceDirectivesID] = useState();
  const [advanceDirectivesValidationModal, setAdvanceDirectivesValidationModal] = useState(ValidationModal)
  const [advanceDirectivesSaveUpdateModal, setAdvanceDirectivesSaveUpdateModal] = useState({})
  const [mainAdvanceDirectivesModal, setMainAdvanceDirectivesModal] = useState(AdvanceDirectives_Modal);
  const [isLoading, setIsLoading] = useState(false)
  const [onAdvanceDirectivesSaved, setOnAdvanceDirectivesSaved] = useState(false)
  const [del, setDel] = useState(false)

  useEffect(() => {
    if (props.advanceDirectivesID != null) {
      setDel(true)
      setAdvanceDirectivesID(props.advanceDirectivesID)
    } else {
      if (!onAdvanceDirectivesSaved) {
        setAdvanceDirectivesID(0);
        setDel(false)
      } else {
        setDel(true)
      }
    }
    if (!isNull(advanceDirectivesID)) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "ID": advanceDirectivesID,
        "TableName": enumUtil.enumAPITableName.PatientAdvanceDirectives
      }).then((response) => {
        setIsLoading(false);
        setMainAdvanceDirectivesModal(response);
      }).catch((error) => {
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        setIsLoading(false)
      })
    }
  }, [advanceDirectivesID])

  const AdvanceDirectivesValidation = async () => {
    let ValidationModal = {
      NotesVal: FormValidator(
        mainAdvanceDirectivesModal.Notes,
        enumUtil.enumValidationType.Required,
        'Notes',
      ),
      // StatusVal: FormValidator(
      //     mainAdvanceDirectivesModal.Status,
      //     enumUtil.enumValidationType.Required,
      //     'Status',
      // ),

    }
    await setAdvanceDirectivesValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  const addNewAdvanceDirectives = () => {
    props.setAdvanceDirectivesID(null);
    setAdvanceDirectivesID(null)
    handleClear();
  }
  const handleSaveAdvanceDirectives = async (type) => {
    if(!IsEditAllowed) return;
    await AdvanceDirectivesValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      setAdvanceDirectivesSaveUpdateModal(advanceDirectivesSaveUpdateModal)
      let saveModal = {
        TableName: enumUtil.enumAPITableName.PatientAdvanceDirectives,
        ID: advanceDirectivesID,
        data: { PatientID: patientID, ...advanceDirectivesSaveUpdateModal },
        value: null
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
            props.setIsRecordSaved(true);
            if (type === "Add Another") {
              addNewAdvanceDirectives();
            } else {
              onClose();
            }
            // setOnAdvanceDirectivesSaved(true)
          }
        }).catch((error) => {
          setIsLoading(false)
          // console.log('error', error);
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
  }

  const handleClear = () => {
    setMainAdvanceDirectivesModal(AdvanceDirectives_Modal);
    setAdvanceDirectivesSaveUpdateModal({});
  }
  const handleChange = (e) => {
    let { name, value } = e.target
    let modal = { ...mainAdvanceDirectivesModal };
    let saveModal = { ...advanceDirectivesSaveUpdateModal }
    modal[name] = value
    setMainAdvanceDirectivesModal(modal)
    for (var property in AdvanceDirectives_Modal) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setAdvanceDirectivesSaveUpdateModal(saveModal)
  }

  const AdvanceDirectivesName = () => {
    return (
      <p className="heading">Advance Directives</p>
    )
  }

  const handleDeleteModal = () => {
    setisOpenDeleteAlert(true)
  }
  const onCloseDelete = () => {
    setisOpenDeleteAlert(false);
  }
  const onDelete = () => {
    props.setIsRecordSaved(true);
    setisOpenDeleteAlert(false);
    onClose();
  }

  let DeleteConfirmation = "";
  if (isOpenDeleteAlert) {
    DeleteConfirmation = (
      <DeleteConfirmatiom
        isOpenAlert={isOpenDeleteAlert}
        hideReason={true}
        API_URL={API_URL}
        TableName={enumUtil.enumAPITableName.PatientAdvanceDirectives}
        ID={advanceDirectivesID}
        onCloseDelete={onCloseDelete}
        onClose={onDelete}
      />
    );
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = (
      <button
        className={
          props?.IsDeleteAllowed
            ? 
          "btn-icon-transparent"
            : 
            "btn-icon-transparent delete-btn-disabled"
        } onClick={handleDeleteModal}>
        <span className="icon"><i className="icon-delete"></i></span>
        <span className="title">Delete</span>
      </button>
    );
  }
  const textareaRef = useRef(null);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.setProperty('height', 'auto', 'important');
      textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
    }
  };
  useEffect(() => {
    adjustTextareaHeight();
  }, [mainAdvanceDirectivesModal.Notes]);
  return (
    <Modal show={isOpenAdvanceDirectives} onHide={isOpenAdvanceDirectives} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
      <Modal.Body>
        {DeleteConfirmation}
        {isLoading && <Loader />}
        <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={AdvanceDirectivesName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
        <div className="">
          <div className={`input my-2 ${advanceDirectivesValidationModal.NotesVal ? 'error' : ''}`}>
            <textarea
              className="form-control overflow-hidden"
              ref={textareaRef}
              onInput={adjustTextareaHeight}
              rows="3"
              name="Notes"
              id="Notes"
              value={mainAdvanceDirectivesModal.Notes}
              onChange={handleChange}
            ></textarea>
            {advanceDirectivesValidationModal.NotesVal}
          </div>
        </div>
      </Modal.Body>

      <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
        <div className="d-flex align-items-center gap-2">
          <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveAdvanceDirectives("Add Another")}>Save & Add Another</button>
          <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveAdvanceDirectives}>Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default AddNewAdvanceDirectives